import React, { useEffect, useState, useMemo } from "react";

import {
  Container,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownItem,
  DropdownMenu,
  Nav,
  NavItem,
  NavLink,
  Row,
  Card,
  Col,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button
} from "reactstrap";
import classnames from "classnames";

import DeleteModal from "../../Components/Common/DeleteModal";

import BreadCrumb from "../../Components/Common/BreadCrumb";
import TableContainer from "../../Components/Common/TableContainer";

import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { deleteProduct, listSubscriptionPlans, updateSubscriptionPlanStatus } from "./_requests";
import { useToast } from "../../Components/Common/ToastContext";
const EcommercePlanSubscription = (props: any) => {
  const { toaster, clearToast } = useToast();
  const navigate = useNavigate();

  const [productList, setProductList] = useState<any>([]);
  const [activeTab, setActiveTab] = useState<any>("1");
  const [product, setProduct] = useState<any>(null);

  const productLists = () => {
    listSubscriptionPlans().then((res: any) => {
      console.log("res.data productLists ", res.data);

      // Ensure the data is an array
      const plans = Array.isArray(res.data) ? res.data : [];
      setProductList(plans);
    }).catch((err: any) => {
      console.error("Error fetching products:", err);
    });
  };


  console.log("productList", productList);
  useEffect(() => {
    if (toaster?.message) {
      if (toaster.status === true) {
        toast.success(toaster.message, { autoClose: 3000 });
      } else {
        toast.error(toaster.message, { autoClose: 3000 });
      }

      clearToast(); // Clear the toast data after showing
    }
    productLists();
  }, [toaster, clearToast]);

  useEffect(() => {
    productLists();
  }, []);

  const toggleTab = (tab: any, type: any) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredProducts = productList;
      if (type !== "all") {
        filteredProducts = productList.filter(
          (product: any) => product.status === type
        );
      }
      setProductList(filteredProducts);
    }
  };

  useEffect(() => {
    const sliderq = document.getElementById("product-price-range");
    sliderq?.setAttribute("data-slider-color", "success");
  }, []);

  const [deleteModalMulti, setDeleteModalMulti] = useState<boolean>(false);

  const [dele, setDele] = useState(0);

  // Displat Delete Button
  const displayDelete = () => {
    const ele = document.querySelectorAll(".productCheckBox:checked");
    const del = document.getElementById("selection-element") as HTMLElement;
    setDele(ele.length);
    if (ele.length === 0) {
      del.style.display = "none";
    } else {
      del.style.display = "block";
    }
  };

  const handleEdit = (row: any) => {
    navigate(`/plan-subscription/edit/${row.id}`, { state: { initialValues: row } });
  };
  const handleDelete = (row: any) => {
    navigate(`/plan-subscription/edit/${row.id}`, { state: { initialValues: row } });
  };
  const handleView = (row: any) => {
    navigate(`/plan-subscription/view/${row.id}`);
  };

  const [galleryModal, setGalleryModal] = useState<boolean>(false);
  const [selectedGallery, setSelectedGallery] = useState<any[]>([]);
  const [selectedPlanName, setSelectedPlanName] = useState<string>("");

  const handleShowGallery = (row: any) => {
    setSelectedGallery(row.gallery || []);
    setSelectedPlanName(row.name);
    setGalleryModal(true);
  };

  const [statusModalOpen, setStatusModalOpen] = useState<boolean>(false);
  const [pendingStatusData, setPendingStatusData] = useState<any>(null);

  const toggleStatusModal = () => setStatusModalOpen(!statusModalOpen);

  const handleStatusToggle = (row: any) => {
    const newStatus = !row.enable_disable_status;
    const action = newStatus ? "Activate" : "Deactivate";
    setPendingStatusData({ id: row.id, newStatus, action });
    toggleStatusModal();
  };

  const confirmStatusUpdate = async () => {
    if (pendingStatusData) {
      const { id, newStatus, action } = pendingStatusData;

      // 1. Prepare the update sequence locally
      const updatedListSnapshot = productList.map((p: any) => {
        if (p.id === id) return { ...p, enable_disable_status: newStatus };
        return p;
      });

      // 2. Filter and Rank Active Plans
      const activePlans = updatedListSnapshot
        .filter((p: any) => p.enable_disable_status === true)
        .sort((a: any, b: any) => {
          // Normalize the sequence: if a plan was just activated (was order 0), it moves to the end of the active list
          if (a.list_order === 0 && b.list_order !== 0) return 1;
          if (a.list_order !== 0 && b.list_order === 0) return -1;
          return a.list_order - b.list_order || b.id - a.id;
        });

      const inactivePlans = updatedListSnapshot.filter((p: any) => p.enable_disable_status === false);

      // 3. Create final mapping based on status
      const finalMapping = [
        ...activePlans.map((p: any, i: number) => ({ id: p.id, list_order: i + 1, status: true })),
        ...inactivePlans.map((p: any) => ({ id: p.id, list_order: 0, status: false }))
      ];

      try {
        // 4. Update the server for any plans that shifted or changed status
        for (const item of finalMapping) {
          const original = productList.find((p: any) => p.id === item.id);
          if (original && (original.list_order !== item.list_order || original.enable_disable_status !== item.status)) {
            await updateSubscriptionPlanStatus(item.id, {
              enable_disable_status: item.status,
              list_order: item.list_order
            });
          }
        }

        toast.success(`Plan ${action}d and list reordered successfully`);
        productLists();
      } catch (error) {
        console.error("Status update error:", error);
        toast.error(`Failed to completely update plan ${action.toLowerCase()} sequence`);
        productLists();
      }
    }
    toggleStatusModal();
  };

  const handleOrderUpdate = async (row: any, newOrder: number) => {
    if (isNaN(newOrder) || !row.enable_disable_status) return;

    // 1. Prepare a virtual update of the list
    const updatedListSnapshot = productList.map((p: any) => {
      if (p.id === row.id) return { ...p, list_order: newOrder };
      return p;
    });

    // 2. Sort active plans based on the new desired order
    const activePlans = updatedListSnapshot
      .filter((p: any) => p.enable_disable_status === true)
      .sort((a: any, b: any) => {
        if (a.list_order !== b.list_order) return a.list_order - b.list_order;
        if (a.id === row.id) return -1;
        if (b.id === row.id) return 1;
        return b.id - a.id;
      });

    const inactivePlans = updatedListSnapshot.filter((p: any) => p.enable_disable_status === false);

    // 3. Create final mapping with clean, unique ranks
    const finalMapping = [
      ...activePlans.map((p: any, i: number) => ({ id: p.id, list_order: i + 1, status: true })),
      ...inactivePlans.map((p: any) => ({ id: p.id, list_order: 0, status: false }))
    ];

    try {
      for (const item of finalMapping) {
        const original = productList.find((p: any) => p.id === item.id);
        if (original && (original.list_order !== item.list_order)) {
          await updateSubscriptionPlanStatus(item.id, { list_order: item.list_order });
        }
      }
      toast.success("Order sequence updated successfully");
      productLists();
    } catch (error) {
      console.error("Reordering failed:", error);
      toast.error("Failed to reorder plans");
      productLists();
    }
  };

  const columns = useMemo(
    () => [
      {
        header: "S.No",
        cell: (cell: any) => {
          return cell.table.getSortedRowModel().flatRows.indexOf(cell.row) + 1;
        },
        id: "serial",
        enableSorting: false,
        enableColumnFilter: false,
      },

      {
        header: "Plan ",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const { image, details, id } = cell.row.original;

          return (
            <div className="d-flex flex-column">
              <div className="d-flex align-items-center mb-2">
                <div className="flex-shrink-0 me-3">
                  <div className="avatar-sm bg-light rounded p-1">
                    <img src={image} alt="" className="img-fluid d-block" />
                  </div>
                </div>
                <div className="flex-grow-1">
                  <h5 className="fs-14 mb-1">
                    <Link to={`/plan-subscription/view/${id}`} className="text-info fw-bold" onClick={(e) => { e.preventDefault(); handleView(cell.row.original); }}>
                      {cell.getValue()}
                    </Link>
                  </h5>
                  {cell.row.original.gallery?.length > 0 && (
                    <div className="mt-0">
                      <Link to="#" className="text-primary small fw-medium" onClick={(e) => { e.preventDefault(); handleShowGallery(cell.row.original); }}>
                        <i className="ri-image-2-line me-1"></i> {cell.row.original.gallery.length} Gallery Images
                      </Link>
                    </div>
                  )}
                </div>
              </div>

              <div className="table-responsive">
                <Table striped bordered className="bg-white rounded mb-0">
                  <thead className="table-light">
                    <tr>
                      <th>#</th>
                      <th>Product</th>
                      <th>Category</th>
                      <th>Variant</th>
                      <th>Price</th>
                      <th>Validity</th>
                      <th>Bonus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {details?.length > 0 ? (
                      details.map((detail: any, index: number) => (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td>{detail.product?.name || "N/A"}</td>
                          <td>{detail.category?.name || "N/A"}</td>
                          <td>{detail.variant_value} {detail.variant?.name || ""}</td>
                          <td>₹{detail.gross_amount}</td>
                          <td>{detail.validity} {detail.validity_type}</td>
                          <td>
                            {detail?.is_loyalty_bonus === true ? (
                              <span className="badge bg-success">Yes</span>
                            ) : detail?.is_loyalty_bonus === false ? (
                              <span className="badge bg-danger">No</span>
                            ) : (
                              <span className="badge bg-secondary">-</span>
                            )}
                          </td>

                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={6} className="text-center">
                          No variants available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </div>
          );
        }

      },

      {
        header: "Type",
        accessorKey: "name",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const row = cell.row.original;
          return (
            <div>
              <p className="text-primary fw-medium mb-0">{row.type_name}</p>
              {row.type === 3 && (
                <div className="mt-1 border-top pt-1">
                  <small className="text-info d-block fw-bold">
                    <i className="ri-shopping-cart-2-line me-1"></i> {row.max_purchase_count} orders limit
                  </small>
                  <small className="text-primary d-block fw-bold">
                    <i className="ri-archive-line me-1"></i> Max {row.max_purchase_product} products selection
                  </small>
                </div>
              )}
            </div>
          );
        },
      },
      {
        header: "Cancel Limit",
        accessorKey: "max_cancel_validity_days",
        enableColumnFilter: false,
        cell: ({ row }) => {
          const cancelDays = row.original.max_cancel_validity_days;
          return <span className="text-danger fw-bold">{cancelDays} Days</span>;
        }
      },
      {
        header: "User Count",
        accessorKey: "user_count",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <span className="text-success fw-bold">{cell.getValue()}</span>
        ),
      },
      {
        header: "Order",
        accessorKey: "list_order",
        enableColumnFilter: false,
        cell: (cell: any) => (
          <input
            type="number"
            className="form-control form-control-sm text-center"
            style={{ 
                width: "70px", 
                backgroundColor: !cell.row.original.enable_disable_status ? "#f3f3f3" : "white",
                cursor: !cell.row.original.enable_disable_status ? "not-allowed" : "text"
            }}
            defaultValue={cell.row.original.enable_disable_status ? cell.getValue() || 0 : 0}
            key={`${cell.row.original.id}-${cell.row.original.enable_disable_status}-${cell.getValue()}`}
            disabled={!cell.row.original.enable_disable_status}
            onBlur={(e) => {
              const newValue = parseInt(e.target.value);
              if (cell.row.original.enable_disable_status && !isNaN(newValue) && newValue !== cell.row.original.list_order) {
                handleOrderUpdate(cell.row.original, newValue);
              }
            }}
          />
        ),
      },
      {
        header: "Status",
        accessorKey: "enable_disable_status",
        enableColumnFilter: false,
        cell: (cell: any) => {
          return (
            <div className="form-check form-switch card-status-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                checked={cell.getValue()}
                onChange={() => handleStatusToggle(cell.row.original)}
              />
            </div>
          );
        },
      },
      {
        header: "Referral Details",
        accessorKey: "referral_status",
        enableColumnFilter: false,
        cell: ({ row }) => {
          const referral = row.original;
          return (
            <div className="d-flex flex-column small">
              <div>
                <span className={`badge ${referral.referral_status ? 'bg-success' : 'bg-secondary'}`}>
                  {referral.referral_status ? '✓ Active' : '✗ Inactive'}
                </span>
              </div>
             {referral.referral_status && (
          <>
           
            <div className="d-flex align-items-center gap-1">
              <span>Deliveries:</span>
              <span>{referral.no_of_delivery_days}</span>
            </div>
             <div className="d-flex align-items-center gap-1">
              <span>Uses:</span>
              <span>{referral.no_of_times_used} time</span>
            </div>
          </>
        )}

            </div>
          );
        }
      },
      {
        header: "Total Amount",
        accessorKey: "total_gross_amount",
        enableColumnFilter: false,
        cell: (cell: any) => {
          const rowData = cell.row.original;
          const total_actual_amount = Number(rowData.total_actual_amount) || 0;
          const total_gross_amount = Number(rowData.total_gross_amount) || 0;
          const total_offer_amount = Number(rowData.total_offer_amount) || 0;

          return (
            <div className="text-muted mb-0">
              {/* Show Offer Amount only if not 0.00 */}
              {total_offer_amount !== 0 && (
                <>
                  {/* Total Actual Amount (Strikethrough & Red) */}
                  <p className="text-muted" style={{ textDecoration: "line-through" }}>
                    ₹{total_actual_amount.toFixed(2)}
                  </p>
                  <p>
                    <span className="mr-1">↓</span>
                    <span
                      className={
                        total_actual_amount > total_gross_amount
                          ? "text-danger"
                          : "text-success"
                      }
                    >
                      {total_actual_amount > total_gross_amount ? "- " : "+ "}
                      ₹{Math.abs(total_offer_amount).toFixed(2)}
                    </span>
                  </p>
                </>
              )}

              {/* Total Gross Amount */}
              <p className="font-bold text-success fw-bold">
                ₹{total_gross_amount.toFixed(2)}
              </p>
            </div>
          );
        },
      },



      {
        header: "Action",
        cell: (cell: any) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0">
              <li className="list-inline-item" title="View">
                <Link
                  to="#"
                  className="text-primary d-inline-block"
                  onClick={(e) => { e.preventDefault(); handleView(cell.row.original); }}
                >
                  <i className="ri-eye-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item edit" title="Edit">
                <Link
                  to="#"
                  className="text-primary d-inline-block edit-item-btn"
                  onClick={(e) => { e.preventDefault(); handleEdit(cell.row.original); }}
                >
                  <i className="ri-pencil-fill fs-16"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Remove">
                <Link
                  to="#"
                  className="text-danger d-inline-block remove-item-btn"
                  onClick={() => handleDelete(cell.row.original)}
                >
                  <i className="ri-delete-bin-5-fill fs-16"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleEdit, handleView, handleDelete]
  );

  // Table Body Rendering with Separate Rows for Variants
  const renderTableRows = (data: any[]) => {
    return data.map((row, rowIndex) => {
      const details = row.details || [];

      return (
        <React.Fragment key={rowIndex}>
          {details.map((detail: any, index: number) => (
            <tr key={`${rowIndex}-${index}`}>
              {index === 0 && (
                <>
                  {/* Checkbox and Plan Name should only appear in the first row */}
                  <td rowSpan={details.length}>
                    <input type="checkbox" className="form-check-input" />
                  </td>
                  <td rowSpan={details.length}>
                    <div className="d-flex align-items-center">
                      <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm bg-light rounded p-1">
                          <img
                            src={row.image}
                            alt=""
                            className="img-fluid d-block"
                          />
                        </div>
                      </div>
                      <div className="flex-grow-1">
                        <h5 className="fs-14 mb-1">
                          <Link
                            to={`/plan-subscription/view/${row.id}`}
                            className="text-body"
                          >
                            {row.name}
                          </Link>
                        </h5>
                      </div>
                    </div>
                  </td>
                </>
              )}
              {/* Product Name */}
              <td>{row.total_amount}</td>
              <td>{detail.product.name}</td>
              <td>{detail.category?.name || "N/A"}</td>
              {/* Variant */}
              <td>{`${detail.variant_value} ${detail.variant?.name || ""}`}</td>
              {/* Price */}
              <td>₹{detail.gross_amount}</td>
              {/* Slot */}
              <td>{detail.slot_type_name}</td>
            </tr>
          ))}
        </React.Fragment>
      );
    });
  };

  document.title = " Paal Dappa | Admin panel";

  return (
    <div className="page-content">
      <ToastContainer closeButton={false} limit={1} />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          // deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <BreadCrumb title="Plan Subscription" pageTitle="Paal Dappa" />

        <Row>
          <Col xl={12} lg={12}>
            <div>
              <Card>
                <div className="card-header border-0">
                  <Row className=" align-items-center">
                    {/* <Col>
                      <Nav
                        className="nav-tabs-custom card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "1" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("1", "all");
                            }}
                            href="#"
                          >
                            All{" "}
                            <span className="badge bg-danger-subtle text-danger align-top rounded-pill ms-1">
                              12
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "2" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("2", "published");
                            }}
                            href="#"
                          >
                            Published{" "}
                            <span className="badge bg-danger-subtle text-danger align-top rounded-pill ms-1">
                              5
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            className={classnames(
                              { active: activeTab === "3" },
                              "fw-semibold"
                            )}
                            onClick={() => {
                              toggleTab("3", "draft");
                            }}
                            href="#"
                          >
                            Draft
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </Col> */}
                    <div className="col-auto">
                      <div id="selection-element">
                        <div className="my-n1 d-flex align-items-center text-muted">
                          Select{" "}
                          <div
                            id="select-content"
                            className="text-body fw-semibold px-1"
                          >
                            {dele}
                          </div>{" "}
                          Result{" "}
                          <button
                            type="button"
                            className="btn btn-link link-danger p-0 ms-3"
                            onClick={() => setDeleteModalMulti(true)}
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-auto ms-auto">
                      <div>
                        <Link
                          to="/plan-subscription/add"
                          state={{ nextOrder: (Array.isArray(productList) ? productList.length : 0) + 1 }}
                          className="btn text-white add-btn me-1"
                          style={{
                            backgroundColor: "#28a8df",
                            borderColor: "#28a8df",
                          }}
                        >
                          <i className="ri-add-line align-bottom me-1"></i> Add Plan Subscription
                        </Link>
                      </div>
                    </div>
                  </Row>
                </div>
                <div className="card-body pt-0">
                  {productList ? (
                    <TableContainer
                      columns={columns}
                      data={productList || []}
                      isGlobalFilter={true}
                      customPageSize={10}
                      divClass="table-responsive mb-1"
                      tableClass="align-top table-bordered align-top table-nowrap mb-0"
                      theadClass="table-light text-muted"
                      isPlanSubscriptionFilter={true}
                      SearchPlaceholder="Search Plan Subscription..."
                    />
                  ) : (
                    <div className="py-4 text-center">
                      <div>
                        <i className="ri-search-line display-5 text-success"></i>
                      </div>

                      <div className="mt-4">
                        <h5>Sorry! No Result Found</h5>
                      </div>
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>

      <Modal isOpen={statusModalOpen} toggle={toggleStatusModal} centered>
        <ModalHeader toggle={toggleStatusModal}>Confirm Status Change</ModalHeader>
        <ModalBody>
          Are you sure you want to <strong>{pendingStatusData?.action}</strong> this subscription plan?
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={toggleStatusModal}>Cancel</Button>
          <Button 
            style={{ backgroundColor: "#28a8df", borderColor: "#28a8df" }} 
            className="text-white"
            onClick={confirmStatusUpdate}
          >
            Confirm
          </Button>
        </ModalFooter>
      </Modal>

      {/* Gallery Modal */}
      <Modal isOpen={galleryModal} toggle={() => setGalleryModal(false)} size="lg" centered>
        <ModalHeader toggle={() => setGalleryModal(false)}>
          Gallery: {selectedPlanName}
        </ModalHeader>
        <ModalBody>
          <Row>
            {selectedGallery?.length > 0 ? (
              selectedGallery
                .sort((a, b) => (a.listOrder || 0) - (b.listOrder || 0))
                .map((item, index) => (
                <Col md={4} sm={6} key={item.id} className="mb-3">
                  <Card className="h-100 border shadow-none mb-0">
                    <img 
                      src={item.image} 
                      alt={`Gallery ${index}`} 
                      className="card-img-top img-fluid rounded" 
                      style={{ height: '180px', objectFit: 'cover' }}
                    />
                    <div className="card-footer p-1 text-center bg-light">
                      <small className="text-muted">Order: {item.listOrder || 0}</small>
                    </div>
                  </Card>
                </Col>
              ))
            ) : (
              <Col className="text-center p-5">
                <i className="ri-image-line display-4 text-muted"></i>
                <p className="mt-2 text-muted">No gallery images found for this plan.</p>
              </Col>
            )}
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => setGalleryModal(false)}>Close</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default EcommercePlanSubscription;
